// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2qOh9","label":"styles_label__HXJx1"};